import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, hasMany, belongsTo } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
let TodolistModel = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = hasMany('todo', {
  inverse: 'todolist',
  async: false
}), _dec5 = hasMany('file', {
  inverse: null,
  async: true
}), _dec6 = belongsTo('project', {
  inverse: 'todolists',
  async: false
}), _dec7 = belongsTo('product', {
  inverse: 'todolists',
  async: false
}), _dec8 = attr('boolean', {
  defaultValue: false
}), _class = class TodolistModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "title", _descriptor, this);
    _initializerDefineProperty(this, "description", _descriptor2, this);
    _initializerDefineProperty(this, "date", _descriptor3, this);
    _initializerDefineProperty(this, "todos", _descriptor4, this);
    _initializerDefineProperty(this, "files", _descriptor5, this);
    _initializerDefineProperty(this, "project", _descriptor6, this);
    _initializerDefineProperty(this, "product", _descriptor7, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor8, this);
  }
  get sortTodos() {
    return this.todos.slice().sort((a, b) => new Date(a.date) - new Date(b.date));
  }
  get label() {
    return this.title || '';
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "title", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "description", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "date", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "todos", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "files", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "project", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "product", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { TodolistModel as default };
//# sourceMappingURL=todolist.js.map
